export default __webpack_public_path__ + "static/media/lineto-circular-book.141aa719.woff";